import { useTranslation } from "react-i18next";
import AuthPageShell from "../components/AuthPageShell";
import SetupTwoFA from "../components/SetupTwoFA";

const SetupTwoFAPage = () => {
  const { t } = useTranslation("auth");

  return (
    <AuthPageShell
      title={t("twoFaSetup.pageTitle")}
      subtitle={t("twoFaSetup.pageSubtitle")}
    >
      <SetupTwoFA />
    </AuthPageShell>
  );
};

export default SetupTwoFAPage;
